import styled, { css, DefaultTheme } from 'styled-components';

const ButtonStyled = styled.button`
  ${({ theme }: { theme: DefaultTheme }) => {
    return css`
      background: var(--primary-color);
      width: 100%;
      height: 1.5em;
      border: none;
      border-radius: 0.375em 0.375em 0 0;
      padding: 0.125em 0.75em;
      cursor: move !important;
      display: none;
      &:hover {
        background: var(--color-midnight);
      }
      @media ${theme.mq.min.tablet} {
        display: block;
      }
    `;
  }}
`;

export default ButtonStyled;
